/* ═══════════════════════════════════════════════════════════════
   destacados-promo.js
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Modal "Recibir Aviso" (global, único por página) ─────────────── */
  if (!window.__notifyAvisoInit) {
    window.__notifyAvisoInit = true;

    var notifyModal = document.getElementById('notify-aviso-modal');
    if (notifyModal) {

      function openNotifyModal(productId, size, color, productHandle) {
        var pidInput      = notifyModal.querySelector('#notify-product-id');
        var handleInput   = notifyModal.querySelector('#notify-product-handle');
        var sizeInput     = notifyModal.querySelector('#notify-size');
        var colorInput    = notifyModal.querySelector('#notify-color');
        if (pidInput)    pidInput.value    = productId     || '';
        if (handleInput) handleInput.value = productHandle || '';
        if (sizeInput)   sizeInput.value   = size          || '';
        if (colorInput)  colorInput.value  = color         || '';
        notifyModal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var emailInput = notifyModal.querySelector('#notify-email');
        if (emailInput) setTimeout(function () { emailInput.focus(); }, 350);
      }

      function closeNotifyModal() {
        notifyModal.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      function closeOpenModals() {
        var sizeModal = document.querySelector('.product-size-modal.is-open');
        if (sizeModal) { sizeModal.classList.remove('is-open'); sizeModal.setAttribute('aria-hidden', 'true'); }
        var colorModal = document.querySelector('.product-color-modal.is-open');
        if (colorModal) { colorModal.classList.remove('is-open'); colorModal.setAttribute('aria-hidden', 'true'); }
      }

      document.addEventListener('click', function (e) {
        var hoverNotify = e.target.closest('.product-card__hover-size-notify');
        if (hoverNotify) {
          e.preventDefault();
          var sizeItem   = hoverNotify.closest('.product-card__hover-size-item');
          var sizePill   = sizeItem ? sizeItem.querySelector('.product-card__size-pill') : null;
          var size       = sizePill ? sizePill.dataset.value : '';
          var card       = hoverNotify.closest('product-card');
          var colorRadio = card ? card.querySelector('.js-color-fieldset .variant-option-radio-input:checked') : null;
          var color      = colorRadio ? colorRadio.value : '';
          var productId = '', productHandle = '';
          if (card) {
            var sizeModal = document.getElementById(card.dataset.modalId || '') || card.querySelector('.product-size-modal[id]');
            if (sizeModal) {
              var parts = sizeModal.id.split('-');
              productId = parts[parts.length - 1];
              productHandle = sizeModal.dataset.productHandle || '';
            }
          }
          closeOpenModals();
          openNotifyModal(productId, size, color, productHandle);
          return;
        }

        var sizeHint = e.target.closest('.product-size-modal__size-hint:not(.product-size-modal__size-hint--low)');
        if (sizeHint) {
          e.preventDefault();
          var sizeRow  = sizeHint.closest('.product-size-modal__size-row');
          var size     = sizeRow ? sizeRow.dataset.valueSize : '';
          var sizesDiv = sizeHint.closest('.product-size-modal__sizes');
          var color    = sizesDiv ? sizesDiv.dataset.activeColor : '';
          var sizeMod  = sizeHint.closest('.product-size-modal[id]');
          var productId = '', productHandle = '';
          if (sizeMod) {
            var parts = sizeMod.id.split('-');
            productId = parts[parts.length - 1];
            productHandle = sizeMod.dataset.productHandle || '';
          }
          closeOpenModals();
          openNotifyModal(productId, size, color, productHandle);
          return;
        }
      });

      notifyModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-notify-close]')) closeNotifyModal();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && notifyModal.classList.contains('is-open')) closeNotifyModal();
      });

      notifyModal.addEventListener('click', function (e) {
        var btn = e.target.closest('.notify-modal__submit');
        if (!btn) return;
        e.preventDefault();
        var emailInput    = notifyModal.querySelector('#notify-email');
        var productHandle = notifyModal.querySelector('#notify-product-handle').value.trim();
        var size          = notifyModal.querySelector('#notify-size').value.trim();
        var color         = notifyModal.querySelector('#notify-color').value.trim();
        var email         = emailInput ? emailInput.value.trim() : '';
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          emailInput && emailInput.focus();
          emailInput && (emailInput.style.borderBottomColor = '#CD2A1B');
          notifyModal.querySelector('[data-notify-error]')?.removeAttribute('hidden');
          return;
        }
        emailInput && (emailInput.style.borderBottomColor = '');
        notifyModal.querySelector('[data-notify-error]')?.setAttribute('hidden', '');
        if (!productHandle) return;
        fetch('/products/' + productHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            if (!product || !product.variants) return;
            var match = product.variants.find(function (v) {
              var hasColor = !color || v.options.some(function (o) { return o === color; });
              var hasSize  = !size  || v.options.some(function (o) { return o === size; });
              return hasColor && hasSize;
            });
            if (!match || match.available) return;
            closeNotifyModal();
            var toast = document.getElementById('notify-toast');
            if (toast) { toast.classList.add('is-visible'); setTimeout(function () { toast.classList.remove('is-visible'); }, 5000); }
          })
          .catch(function (err) { console.warn('[Aviso DestacadosPromo]', err); });
      });
    }
  }

  /* ══════════════════════════════════════════════════════════════
     Inicialización de una sección Destacados Promo
  ══════════════════════════════════════════════════════════════ */
  function initDestacadosPromoSection(sectionEl) {
    if (sectionEl.dataset.destacadosPromoInitialized === 'true') return;
    sectionEl.dataset.destacadosPromoInitialized = 'true';

    var sectionId = sectionEl.id.replace('shopify-section-', '');
    var grid      = sectionEl.querySelector('[data-destacados-grid]');
    if (!grid) return;

    /* ── Hoist modals al body ────────────────────────────────── */
    function hoistModals() {
      sectionEl.querySelectorAll('.product-size-modal:not([data-hoisted]), .product-color-modal:not([data-hoisted])').forEach(function (modal) {
        modal.dataset.hoisted = '1';
        document.body.appendChild(modal);
      });
    }
    hoistModals();

    /* ── Selección inicial de color ──────────────────────────── */
    function initDefaultColorSelection() {
      sectionEl.querySelectorAll('product-card:not([data-color-init])').forEach(function (card) {
        card.dataset.colorInit = '1';
        var colorFieldset = card.querySelector('.js-color-fieldset');
        if (!colorFieldset) return;
        var firstRadio = colorFieldset.querySelector('.variant-option-radio-input');
        if (!firstRadio) return;
        if (!firstRadio.checked) {
          colorFieldset.querySelectorAll('.variant-option-radio-input').forEach(function (r) { r.checked = false; });
          firstRadio.checked = true;
        }
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      });

      window.setTimeout(initCardSliders, 300);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDefaultColorSelection);
    } else {
      initDefaultColorSelection();
    }

    /* ── Slider Swiper en cada card ──────────────────────────── */
    function initCardSliders() {
      if (typeof Swiper === 'undefined') {
        window.setTimeout(initCardSliders, 250);
        return;
      }

      sectionEl.querySelectorAll('.product-card__media--slider:not([data-slider-init])').forEach(function (media) {
        var imgs = Array.from(media.querySelectorAll('.slider-img'));
        if (imgs.length <= 1) return;
        var swiperEl  = document.createElement('div');
        swiperEl.className = 'swiper product-card-swiper';
        var wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';
        imgs.forEach(function (img) {
          img.classList.remove('slider-img', 'slider-img--active');
          var slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.appendChild(img);
          wrapper.appendChild(slide);
        });
        var btnPrev  = document.createElement('div'); btnPrev.className  = 'swiper-button-prev';
        var btnNext  = document.createElement('div'); btnNext.className  = 'swiper-button-next';
        var pagination = document.createElement('div'); pagination.className = 'swiper-pagination';
        pagination.style.setProperty('--product-card-pagination-total', imgs.length);
        pagination.style.setProperty('--product-card-pagination-index', 0);
        swiperEl.appendChild(wrapper);
        swiperEl.appendChild(btnPrev);
        swiperEl.appendChild(btnNext);
        swiperEl.appendChild(pagination);
        media.innerHTML = '';
        media.appendChild(swiperEl);
        media.setAttribute('data-slider-init', '1');
        var cardSwiper = new Swiper(swiperEl, {
          loop: true,
          navigation: { prevEl: btnPrev, nextEl: btnNext },
          pagination: {
            el: pagination,
            type: 'bullets',
            bulletClass: 'product-card-swiper__pagination-item',
            bulletActiveClass: 'product-card-swiper__pagination-item--active',
            renderBullet: function (index, className) {
              return '<span class="' + className + '"></span>';
            }
          }
        });

        cardSwiper.on('slideChange', function () {
          pagination.style.setProperty('--product-card-pagination-index', cardSwiper.realIndex);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCardSliders);
    } else {
      initCardSliders();
    }

    /* ── Reveal animation ────────────────────────────────────── */
    if (!Shopify.designMode) {
      var cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('plp-card-revealed');
          cardObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -30px 0px', threshold: 0.05 });
      requestAnimationFrame(function () {
        Array.from(grid.children).forEach(function (card, i) {
          if (!card.classList.contains('plp-card-revealed')) {
            card.style.transitionDelay = (i % 2 * 0.08) + 's';
            cardObserver.observe(card);
          }
        });
      });
    }

    /* ── Añadir al carrito desde pills de talla ──────────────── */
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.product-card__size-pill');
      if (!pill) return;
      var sizesDiv = pill.closest('.product-card__sizes-hover') || pill.closest('.product-size-modal__sizes');
      if (!sizesDiv) return;
      var ownerModal = pill.closest('.product-size-modal[data-section-id]');
      var ownerHover = pill.closest('.product-card__sizes-hover');
      if (ownerModal) {
        if (ownerModal.dataset.sectionId !== sectionId) return;
      } else if (ownerHover) {
        if (!sectionEl.contains(ownerHover)) return;
      } else { return; }

      if (e.__productCardSizeAddHandled) return;
      if (pill.classList.contains('loading')) return;
      e.__productCardSizeAddHandled = true;
      e.stopImmediatePropagation(); e.preventDefault();

      var sizeOptionPos = parseInt(sizesDiv.dataset.sizeOptionPos, 10);
      var sizeValue     = pill.dataset.value;
      var card = pill.closest('product-card');
      if (!card) {
        var modal = pill.closest('.product-size-modal[id]');
        if (modal) {
          card = sectionEl.querySelector('product-card[data-modal-id="' + modal.id + '"]');
          if (!card) {
            var ctaBtn = sectionEl.querySelector('.cta-add-resp[data-opens-modal="' + modal.id + '"]');
            if (ctaBtn) card = ctaBtn.closest('product-card');
          }
        }
      }
      if (!card) return;

      var colorFieldset  = card.querySelector('.js-color-fieldset');
      var selectedColor  = null, colorOptionPos = null;
      if (colorFieldset) {
        colorOptionPos = parseInt(colorFieldset.dataset.optionPos, 10);
        var checkedRadio = colorFieldset.querySelector('.variant-option-radio-input:checked');
        if (checkedRadio) selectedColor = checkedRadio.value;
      }

      var variantsScript = card.querySelector('[data-product-variants-json]');
      if (!variantsScript) return;
      var variants;
      try { variants = JSON.parse(variantsScript.textContent); } catch (err) { return; }

      var targetVariant = variants.find(function (v) {
        if (v['option' + sizeOptionPos] !== sizeValue) return false;
        if (selectedColor && colorOptionPos) return v['option' + colorOptionPos] === selectedColor;
        return true;
      });

      if (!targetVariant || !targetVariant.available) {
        pill.classList.add('unavailable');
        setTimeout(function () { pill.classList.remove('unavailable'); }, 1500);
        return;
      }

      sizesDiv.querySelectorAll('.product-card__size-pill').forEach(function (s) { s.classList.remove('selected', 'added'); });
      pill.classList.add('selected', 'loading');
      window.LolaCartPopupInteraction?.lock();

      var cartPayload  = { id: targetVariant.id, quantity: 1 };
      var popupImage = card.dataset.popupImage || '';
      if (popupImage) cartPayload.properties = { _popup_image: popupImage };

      window.LolaCartGift.request((window.routes?.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(cartPayload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          pill.classList.remove('loading');
          if (data.id) {
            pill.classList.add('added');
            var cartPopupEl = document.querySelector('cart-popup');
            if (cartPopupEl) {
              if (popupImage) data.properties = Object.assign({}, data.properties, { _popup_image: popupImage });
              cartPopupEl.show(data);
            }
            if (typeof updateCartCounters === 'function') {
              updateCartCounters();
            }
            var openModal = pill.closest('.product-size-modal.is-open');
            if (openModal) { openModal.classList.remove('is-open'); openModal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
            setTimeout(function () { pill.classList.remove('added'); }, 2000);
          } else {
            window.LolaCartPopupInteraction?.unlock();
            window.LolaCartError?.show(data);
          }
        })
        .catch(function () { window.LolaCartPopupInteraction?.unlock(); window.LolaCartError?.show(); pill.classList.remove('loading'); });
    });

    /* ── Abrir / cerrar modal de tallas ──────────────────────── */
    sectionEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.cta-add-resp');
      if (!btn) return;
      e.preventDefault();
      var modal = document.getElementById(btn.dataset.opensModal);
      if (modal) { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.product-size-modal__close') || e.target.classList.contains('product-size-modal__backdrop')) {
        var modal = e.target.closest('.product-size-modal');
        if (modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
      }
    });

    /* ── Abrir / cerrar modal de colores ─────────────────────── */
    var colorModalSourceCard = null;

    sectionEl.addEventListener('click', function (e) {
      if (window.innerWidth > 1023) return;
      var fieldset = e.target.closest('.js-color-fieldset[data-opens-color-modal]');
      if (!fieldset) return;
      e.preventDefault(); e.stopPropagation();
      var modal = document.getElementById(fieldset.dataset.opensColorModal);
      if (!modal) return;
      colorModalSourceCard = fieldset.closest('product-card');
      if (colorModalSourceCard) {
        var checkedRadio = colorModalSourceCard.querySelector('.js-color-fieldset .variant-option-radio-input:checked');
        var label = modal.querySelector('[data-color-modal-label]');
        if (checkedRadio && label) label.textContent = checkedRadio.value;
        if (checkedRadio) {
          var modalRadio = modal.querySelector('.variant-option-radio-input[value="' + checkedRadio.value.replace(/"/g, '\\"') + '"]');
          if (modalRadio) modalRadio.checked = true;
        }
      }
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target.closest('.product-color-modal__close') || e.target.classList.contains('product-color-modal__backdrop')) {
        var modal = e.target.closest('.product-color-modal');
        if (modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; colorModalSourceCard = null; }
      }
    });

    /* ── Sincronizar color del modal con la card ─────────────── */
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.product-color-modal .variant-option-radio-input')) return;
      var modal = e.target.closest('.product-color-modal');
      if (!modal) return;
      var colorValue = e.target.value;
      var label = modal.querySelector('[data-color-modal-label]');
      if (label) label.textContent = colorValue;
      if (colorModalSourceCard) {
        var cardRadio = colorModalSourceCard.querySelector('.js-color-fieldset .variant-option-radio-input[value="' + colorValue.replace(/"/g, '\\"') + '"]');
        if (cardRadio) {
          cardRadio.checked = true;
          var selectedDiv = cardRadio.closest('.button--variant');
          if (selectedDiv) {
            var fs = colorModalSourceCard.querySelector('.js-color-fieldset');
            if (fs) {
              var visibleDiv = fs.querySelector('.button--variant:not(.color-swatch-extra)');
              if (visibleDiv && visibleDiv !== selectedDiv) {
                visibleDiv.classList.add('small-hide', 'medium-hide', 'color-swatch-extra');
                selectedDiv.classList.remove('small-hide', 'medium-hide', 'color-swatch-extra');
              }
            }
          }
          cardRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setTimeout(function () { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; colorModalSourceCard = null; }, 200);
    });

    /* ── Actualizar hints de tallas al cambiar color ─────────── */
    document.addEventListener('change', function (e) {
      var radio = e.target;
      if (!radio.matches('.js-color-fieldset .variant-option-radio-input')) return;
      var card = radio.closest('product-card');
      if (!card || !sectionEl.contains(card)) return;
      var newColor   = radio.value;
      var sizesHover = card.querySelector('.product-card__sizes-hover');
      if (sizesHover) {
        sizesHover.querySelectorAll('.product-card__hover-size-item').forEach(function (item) {
          var colorStates;
          try { colorStates = JSON.parse(item.dataset.colorStates || '{}'); } catch (err) { return; }
          var state = colorStates[newColor];
          item.classList.toggle('unavailable', !state || !state.a);
          item.classList.toggle('low-stock',   !!(state && state.l));
        });
      }
      var openBtn = card.querySelector('.cta-add-resp[data-opens-modal]');
      if (!openBtn) return;
      var sizeModal = document.getElementById(openBtn.dataset.opensModal);
      if (!sizeModal) return;
      var sizesDiv = sizeModal.querySelector('.product-size-modal__sizes');
      if (!sizesDiv) return;
      var hintLowStock = sizesDiv.dataset.hintLowStock || 'Últimas unidades';
      var hintNotify   = sizesDiv.dataset.hintNotify   || '';
      sizesDiv.dataset.activeColor = newColor;
      sizesDiv.querySelectorAll('.product-size-modal__size-row').forEach(function (row) {
        var pill = row.querySelector('.product-card__size-pill');
        if (!pill) return;
        var colorStates;
        try { colorStates = JSON.parse(row.dataset.colorStates || '{}'); } catch (err) { return; }
        var state = colorStates[newColor];
        row.querySelectorAll('.product-size-modal__size-hint').forEach(function (h) { h.remove(); });
        if (!state || !state.a) {
          row.classList.add('product-size-modal__size-row--unavailable'); pill.classList.add('unavailable');
          var hint = document.createElement('span'); hint.className = 'product-size-modal__size-hint body-s-regular underlined'; hint.textContent = hintNotify; row.appendChild(hint);
        } else {
          row.classList.remove('product-size-modal__size-row--unavailable'); pill.classList.remove('unavailable');
          if (state.l) { var lowHint = document.createElement('span'); lowHint.className = 'product-size-modal__size-hint product-size-modal__size-hint--low body-s-regular'; lowHint.textContent = hintLowStock; row.appendChild(lowHint); }
        }
      });
    });

    /* ── Mobile: expandir +N colores ────────────────────────── */
    sectionEl.addEventListener('click', function (e) {
      if (window.innerWidth > 1023) return;
      var more = e.target.closest('.product-card__variants--more');
      if (!more) return;
      e.stopPropagation(); e.preventDefault();
      var fs = more.closest('.js-color-fieldset');
      if (fs) fs.classList.toggle('color-option-expanded');
    }, true);

    sectionEl.addEventListener('change', function (e) {
      if (window.innerWidth > 1023) return;
      if (!e.target.matches('.variant-option-radio-input')) return;
      var fs = e.target.closest('.js-color-fieldset.color-option-expanded');
      if (!fs) return;
      var selectedDiv = e.target.closest('.button--variant');
      if (selectedDiv && selectedDiv.classList.contains('color-swatch-extra')) {
        var visibleDiv = fs.querySelector('.button--variant:not(.color-swatch-extra)');
        if (visibleDiv) visibleDiv.classList.add('small-hide', 'medium-hide', 'color-swatch-extra');
        selectedDiv.classList.remove('small-hide', 'medium-hide', 'color-swatch-extra');
      }
      fs.classList.remove('color-option-expanded');
    });

    document.addEventListener('click', function (e) {
      if (window.innerWidth > 1023) return;
      if (e.target.closest('.color-option-expanded')) return;
      sectionEl.querySelectorAll('.color-option-expanded').forEach(function (el) { el.classList.remove('color-option-expanded'); });
    });
  }

  /* ── Auto-init ──────────────────────────────────────────────── */
  document.querySelectorAll('.section-destacados-promo[id^="shopify-section-"]').forEach(initDestacadosPromoSection);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target;
      if (el && el.classList.contains('section-destacados-promo')) initDestacadosPromoSection(el);
    });
  }
}());
